import {
    Card,
    CardContent,
    Divider,
    Grid,
    ListItemButton,
    MenuItem,
    Select,
    SelectChangeEvent,
    Typography,
} from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowUpRightFromSquare } from "@fortawesome/pro-light-svg-icons"
import { Breadcrumb, BreadcrumbLink, StandardBreadcrumbs } from "../../../shared/components/links/StandardBreadcrumbs"
import { LocalizedEnum, LocalizedStrict } from "../../localization/components/AppLocalized"
import { PageHeader } from "../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../shared/components/pageHeader/PageHeaderApi"
import { useLocaleSelect } from "../../localization/localizationHooks"
import { useExternalLinks } from "../../../shared/hooks/useAppLinks"

const useStyles = makeStyles()((theme) => ({
    cardWrap: {
        borderRadius: "0.75rem",
        padding: "2.5rem",
    },
    cardContent: {
        padding: "0",
        display: "grid",
        gap: "3rem",
        "&:last-child": {
            paddingBottom: 0,
        },
    },
    boxTitleColor: {
        color: theme.palette.tailwind.slate[600],
    },
    selectWrap: {
        minWidth: "13.75rem",
    },
    selectTitle: {
        fontWeight: 400,
        color: theme.palette.text.secondary,
    },
    button: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "1.25rem 1rem",
        fontSize: "1rem",
        fontWeight: "300",
        color: theme.palette.tailwind.slate[700],
    },
}))

export function Settings() {
    return (
        <>
            <LocalizedStrict id="settings-page-header" attrs={{ title: true }}>
                <PageHeader page={Page.SETTINGS} title="Settings">
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="settings-nav-item-home">
                            <BreadcrumbLink to={"/"}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="settings-title">
                            <Breadcrumb>Settings</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>
            <SettingsCardContent />
        </>
    )
}

export function SettingsCardContent() {
    const { classes } = useStyles()
    const { supportedLocales, selectedLocale, selectLocale } = useLocaleSelect()

    function handleLocaleChange(event: SelectChangeEvent<string>) {
        selectLocale(event.target.value)
    }

    const handleExternalLink = useExternalLinks()

    return (
        <Card className={classes.cardWrap}>
            <CardContent className={classes.cardContent}>
                <Grid container item justifyContent="space-between" alignItems="center">
                    <LocalizedStrict id="settings-language-setting">
                        <Typography variant="h6" className={classes.boxTitleColor}>
                            Language
                        </Typography>
                    </LocalizedStrict>
                    <Select
                        value={selectedLocale}
                        onChange={handleLocaleChange}
                        size="medium"
                        className={classes.selectWrap}
                    >
                        {supportedLocales.map((locale) => (
                            <MenuItem key={locale} value={locale}>
                                <LocalizedEnum base="language-selector-lang" enumValue={locale}>
                                    <Typography variant="subtitle1" className={classes.selectTitle}>
                                        locale
                                    </Typography>
                                </LocalizedEnum>
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
                <Grid container item flexDirection="column" gap={8}>
                    <Grid>
                        <LocalizedStrict id="settings-social-media-label">
                            <Typography variant="h6" className={classes.boxTitleColor}>
                                Social media
                            </Typography>
                        </LocalizedStrict>
                        <Divider sx={{ marginTop: "1rem" }} />
                        <ListItemButton
                            onClick={() => handleExternalLink("https://www.linkedin.com/company/facilitynet/")}
                            className={classes.button}
                        >
                            <LocalizedStrict id="settings-social-media-text">
                                <span>Follow us on Linkedin</span>
                            </LocalizedStrict>
                            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                        </ListItemButton>
                        <Divider />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}
